/** 备份与迁移文章：每篇正文只放 2 条不重复的内链 */
export const BACKUP_POSTS = {
	'gb-whatsapp-backup-not-working': {
		slug: 'gb-whatsapp-backup-not-working',
		categoryId: 'backup-migration',
		title: 'How to Back Up GB WhatsApp Chats When Backup Fails',
		description:
			'GB WhatsApp Pro backup stuck, missing, or failing. Check free space, local files, and why a Google Drive backup from official WhatsApp does not apply.',
		keywords: 'gb whatsapp backup not working',
		h1: 'GB WhatsApp Backup Not Working',
		lead:
			'A failed backup means the app could not write a copy. Your chats are still in the app until you uninstall or clear data. Do not remove the app to “retry”.',
		body: `
      <h2>Why it stops</h2>
      <p>The usual causes are a full disk, storage permission turned off, or a build that only does local backup while you are looking in Google Drive. Official WhatsApp’s Drive backup is not the same file. GB WhatsApp Pro often cannot see it, and Drive may not see a GB backup either.</p>
      <p>If the bar freezes, keep the screen on, stay on Wi‑Fi, and pause battery saver for this app. Large videos make a backup look stuck. Wait before you cancel. If it has not moved for a long time, note the percent, cancel, free space, and start once more.</p>

      <h2>Make space without deleting chats</h2>
      <ol class="article-steps">
        <li><strong>Free internal storage</strong> by removing downloads and unused apps, not by clearing GB WhatsApp data.</li>
        <li><strong>Allow files or media access</strong> for GB WhatsApp Pro when Android asks.</li>
        <li><strong>Run the backup from inside the app</strong> and wait until it shows a time, not only a spinning icon.</li>
      </ol>
      <p>Clearing “cached data” in Android can be safe. Clearing storage for the app is not. That second button deletes the chats you are trying to save. If the phone is too full to finish, follow <a href="/help/storage-problems/">freeing space on the phone without wiping GB WhatsApp chats</a>.</p>

      <h2>Check that a file exists</h2>
      <p>Open the in-app backup screen and look for a date. If you copy a folder by hand, copy it to a computer or a card you control, then check the file size is not zero. Only after you can see that copy should you reinstall. Putting it back is a separate step: <a href="/restore-gb-whatsapp-chats/">restoring GB WhatsApp chats from a backup you already have</a>.</p>
    `,
		faqs: [
			['Will uninstall delete chats if backup failed?', 'Yes, in most cases. Local chats go with the app when there is no finished backup or export.'],
		],
		publishedAt: '2026-10-27',
		updatedAt: '2026-11-04',
		coverTheme: 'safe',
		coverLabel: 'Backup',
	},
	'restore-gb-whatsapp-chats': {
		slug: 'restore-gb-whatsapp-chats',
		categoryId: 'backup-migration',
		title: 'How to Restore GB WhatsApp Chats from a Backup',
		description:
			'Restore GB WhatsApp Pro chats only when a compatible backup is on the phone. Here is what to do if the restore button never appears.',
		keywords: 'restore gb whatsapp chats',
		h1: 'How to Restore GB WhatsApp Chats',
		lead:
			'Restore works when a backup from a compatible GB WhatsApp Pro build is already on the phone. If the button never shows, the file is missing, in the wrong place, or from another app.',
		body: `
      <h2>Before you tap restore</h2>
      <p>You need three things: a backup that finished, enough free space to unpack it, and a GB WhatsApp Pro install that can read that backup. A file from a different mod, or a Google Drive backup made only in official WhatsApp, often will not appear in the list.</p>
      <p>If you are not sure a backup was ever written, stop and create one on a phone where the chats still open. <a href="/gb-whatsapp-backup-not-working/">When GB WhatsApp backup fails before a file exists</a> is the step to finish first. Restoring cannot invent chats that were never copied.</p>

      <h2>Restore on a matching install</h2>
      <ol class="article-steps">
        <li><strong>Install the same GB line</strong> you backed up, not a different publisher’s APK with a similar name.</li>
        <li><strong>Allow storage access</strong> before you verify the number, if the prompt appears.</li>
        <li><strong>Choose restore when registration offers it.</strong> If you skip that screen, you may have to reinstall to see it again. Copy the backup file somewhere safe before you do.</li>
      </ol>
      <p>Text can show up before photos. Stay on Wi‑Fi and let media finish. Do not clear cache in the middle, or those photos may have to download again from a server an old build can no longer reach. The first-launch prompt is also described in <a href="/installation/restore-chats/">restoring chats the first time GB WhatsApp Pro opens</a>.</p>

      <h2>If older chats would be overwritten</h2>
      <p>A restore replaces what is in the app with the backup. If this phone already has newer messages you care about, copy the current backup out before you test an older file. There is no undo inside the chat list.</p>
    `,
		faqs: [
			['Can official WhatsApp open a GB backup?', 'Usually no. The formats differ. Do not rename folders and expect the official app to read them.'],
		],
		publishedAt: '2026-10-28',
		updatedAt: '2026-11-04',
		coverTheme: 'safe',
		coverLabel: 'Restore',
	},
	'switch-from-gb-whatsapp-to-official-whatsapp': {
		slug: 'switch-from-gb-whatsapp-to-official-whatsapp',
		categoryId: 'backup-migration',
		title: 'Switch from GB WhatsApp to Official WhatsApp Safely',
		description:
			'Move a number from GB WhatsApp Pro to official WhatsApp. Export what you can first, and do not expect every mod backup to import.',
		keywords: 'switch from gb whatsapp to official whatsapp',
		h1: 'How to Switch from GB WhatsApp to Official WhatsApp',
		lead:
			'You can move the phone number to official WhatsApp. Chat history from GB WhatsApp Pro often does not come with it. Copy what you need while the mod still opens.',
		body: `
      <h2>What will and will not move</h2>
      <p>Official WhatsApp restores backups it created, usually through Google Drive on Android. A backup folder made only inside GB WhatsApp Pro is a different file. Renaming it does not make the official app accept it. Photos already saved in your gallery stay on the phone even when the chat thread does not import.</p>
      <p>If GB WhatsApp still opens, export important chats from the chat menu and save the attachments you need. A text export is a record. It will not reappear as a WhatsApp thread. Do that before you uninstall.</p>

      <h2>Set up the official app</h2>
      <ol class="article-steps">
        <li><strong>Install WhatsApp from Google Play</strong> or the store you already trust. Skip unofficial “official” APK pages.</li>
        <li><strong>Verify the same number</strong> you used in GB WhatsApp Pro.</li>
        <li><strong>Restore only if the official app finds its own backup.</strong> If it does not offer one, the GB copy was never in Drive.</li>
      </ol>
      <p>Keep the GB backup on a computer until you are sure you do not need the text export. Limits of putting a GB file back into a mod, if you change your mind, are in <a href="/restore-gb-whatsapp-chats/">why a GB WhatsApp backup may not restore</a>.</p>

      <h2>If the number is already limited</h2>
      <p>Switching apps does not erase a restriction WhatsApp already applied. If you see a timer or a block, read that message before you install another mod “to get the chats”. <a href="/why-is-gb-whatsapp-account-banned/">What a GB WhatsApp restriction timer means</a> matters more than which APK you open next. Finish any export the current app still allows, then follow the on-screen instruction.</p>
    `,
		faqs: [
			['Will I lose photos?', 'Photos you already saved to the gallery stay. Photos that lived only inside the mod may not import. Save those files first.'],
		],
		publishedAt: '2026-10-29',
		updatedAt: '2026-11-04',
		coverTheme: 'safe',
		coverLabel: 'Migration',
	},
	'transfer-gb-whatsapp-to-new-phone': {
		slug: 'transfer-gb-whatsapp-to-new-phone',
		categoryId: 'backup-migration',
		title: 'How to Transfer GB WhatsApp to a New Phone',
		description:
			'Move GB WhatsApp Pro to a new Android phone with a real backup. Phone-clone apps often skip the chat database.',
		keywords: 'transfer gb whatsapp new phone',
		h1: 'How to Transfer GB WhatsApp to a New Phone',
		lead:
			'Chats move only if you copy a backup the new phone can read. A phone-clone app can copy the icon and still leave the chat history behind.',
		body: `
      <h2>On the old phone</h2>
      <ol class="article-steps">
        <li><strong>Note the exact GB WhatsApp Pro version</strong> in Settings → About.</li>
        <li><strong>Run a backup and wait for a timestamp.</strong> A spinner is not a finished file.</li>
        <li><strong>Copy that backup to a computer</strong> or a storage card you control. Do not post the database in a public link.</li>
      </ol>
      <p>Samsung Smart Switch, Xiaomi movers, and similar tools often skip the encrypted chat database. Use them for photos if you want. Still make the in-app backup. The place that backup is written is covered in <a href="/installation/backup-chats/">where GB WhatsApp stores a local chat backup</a>.</p>

      <h2>On the new phone</h2>
      <p>Check the new phone’s Android version can run the same build before you wipe the old phone. Put the backup on internal storage, install the same GB line, then verify the number. Accept restore if it is offered during setup. If the old phone used a removable SD card for media, insert that card before the first open, or the paths will point at a drive that is not there.</p>
      <p>If chats are missing after setup, do not verify again in a loop. Copy the backup file back into place and reinstall once. The prompt you should see is explained in <a href="/restore-gb-whatsapp-chats/">restoring chats onto the new phone from that backup</a>.</p>

      <h2>What does not come across</h2>
      <p>Themes, a chat lock PIN, and some GB-only switches often reset. A new phone number is a new registration, not a transfer. Dual-SIM phones should verify the same SIM you used before, or the backup will not match the account.</p>
    `,
		faqs: [
			['Can I clone the whole app?', 'Clone tools often miss the chat database. Use the in-app backup and copy that file yourself.'],
		],
		publishedAt: '2026-10-30',
		updatedAt: '2026-11-04',
		coverTheme: 'safe',
		coverLabel: 'New Phone',
	},
}
